import React, {useEffect, useState} from 'react';
import ReactModal from "react-modal";

import "./GatesPerspectiveCapture.css";
import {StandardButton} from "../../../common/button/standard-button/StandardButton";
import {FileUploadButton} from "../../../common/button/file-upload-button/FileUploadButton";
import {deleteFile, uploadFile} from "../../../../services/FileService";
import {appBaseURL, downloadURL} from "../../../../config/URLConfig";

export const GatesPerspectiveCapture = ({
                                            context,
                                            navigateTo,
                                            setContext,
                                            setSpinnerText,
                                            showToaster
                                        }) => {

    ReactModal.setAppElement('#root');

    const [externalReference] = useState(context.selectedFile ? context.selectedFile.externalReference : null);
    const [fileName, setFileName] = useState(context.selectedFile ? context.selectedFile.name : "No File Selected");
    const [file, setFile] = useState(null);
    const [disabled, setDisabled] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [libraryName, setLibraryName] = useState("");

    useEffect(() => {
        setLibraryName(context.libraryName);
        if (file) {
            if (file.size > 16777216) {
                setShowModal(true);
                setFile(null);
            } else {
                setFileName(file.name);
            }
        }
        if (file) {
            setDisabled(false);
        }
    }, [file]);


    const handleUploadClick = async () => {
        if (context.captureNewLibrary) {
            addFileToUploadListOnCreate();
        } else {
            if (context.selectedFile) {
                await updateFileInExistingLibrary()
            } else {
                await addFileToExistingLibrary();
            }
        }
    }

    const addFileToUploadListOnCreate = () => {
        const copyOfFilesToUploadList = JSON.parse(JSON.stringify(context.filesToUploadList));
        copyOfFilesToUploadList.push(file);
        setContext((prevState) => ({
            ...prevState,
            addFilesToLibrary: true,
            filesToUploadList: copyOfFilesToUploadList,
        }));
        navigateTo("gatesPerspectiveTable");
    }

    const addFileToExistingLibrary = async () => {
        await uploadGatesFile("Uploading file...")
        setContext((prevState) => ({
            ...prevState,
            addFilesToLibrary: true,
        }));
        navigateTo("gatesPerspectiveTable");
    }

    const updateFileInExistingLibrary = async () => {
        await uploadGatesFile("Updating file...");
        await handleDeleteClick();
        setContext((prevState) => ({
            ...prevState,
            captureNewLibrary: false,
            addFilesToLibrary: true,
        }));
        navigateTo("gatesPerspectiveTable");
    }

    const uploadGatesFile = async (message) => {
        setSpinnerText(message);
        const gatesFileVOToCreate = {
            name: file.name,
            creatorExternalReference: context.loggedInUser.externalReference,
            modifiedByExternalReference: context.loggedInUser.externalReference,
            contextObjectReferenceVO: {
                externalReference: context.selectedLibrary.externalReference,
                contextId: 30,
            },
            category: "gates",
            data: file.data,
            visibility: context.selectedLibrary.visibility,
        }
        const [data, error] = await uploadFile(context.loggedInUser, gatesFileVOToCreate);
        if (data) {
            showToaster(data);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        setSpinnerText(null);
    }

    const handleDeleteClick = async () => {
        if (context.captureNewLibrary) {
            setSpinnerText("Removing file...");
            const copyOfFilesToUploadList = JSON.parse(JSON.stringify(context.filesToUploadList));
            const copyOfSelectedFile = JSON.parse(JSON.stringify(context.selectedFile));
            copyOfFilesToUploadList.splice(copyOfFilesToUploadList.indexOf(copyOfSelectedFile), 1);
            setContext((prevState) => ({
                ...prevState,
                filesToUploadList: copyOfFilesToUploadList,
            }));
            navigateTo("gatesPerspectiveTable");
            setSpinnerText(null);
        } else {
            setSpinnerText("Deleting file...");
            const [data, error] = await deleteFile(context.username, externalReference);
            if (data) {
                navigateTo("gatesPerspectiveTable");
                showToaster(data);
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
            setSpinnerText(null);
        }
    }

    const handleDownloadClick = async () => {
        window.open(appBaseURL + downloadURL + externalReference);
    }

    const navigateBackToCaptureOrUpdate = () => {
        const lastScreen = context.viewStack.pop();
        setContext((prevState) => ({
            ...prevState,
            currentScreen: lastScreen,
            viewStack: [...context.viewStack],
            captureNewLibrary: context.captureNewLibrary,
            addFilesToLibrary: true,
            addClick: false,
            selectedFile: null,
        }));
    };

    const navigateBackToLibraryUpdate = () => {
        const lastScreen = context.viewStack.pop();
        setContext((prevState) => ({
            ...prevState,
            currentScreen: lastScreen,
            viewStack: [...context.viewStack],
            captureNewLibrary: context.captureNewLibrary,
            addFilesToLibrary: true,
            addClick: false,
            selectedFile: null,
        }));
    };

    return (
        <div className="gates-perspective-capture-container">
            <div className="gates-perspective-capture-form-container">
                <div className="gates-perspective-text-input-container">
                    <label>Grant Library Name:</label>
                    <input type="text" value={libraryName} disabled={true}/>
                </div>
                <div className="gates-perspective-text-input-container">
                    <label>File Name:</label>
                    <input type="text" value={fileName} disabled={true}/>
                </div>
            </div>

            <div className="gates-perspective-capture-button-container">
                <FileUploadButton buttonText="Select File" setFile={setFile}/>

                {context.selectedFile &&
                <StandardButton text="Download File" onClick={handleDownloadClick}/>}
                <StandardButton disabled={!file} text={(!context.selectedFile) ? "Upload File" : "Update File"}
                                onClick={handleUploadClick}/>

                {context.selectedFile &&
                <StandardButton text={"Delete File"} onClick={handleDeleteClick}/>}
                <StandardButton text="Back"
                                onClick={(context.selectedFile) ? navigateBackToLibraryUpdate : navigateBackToCaptureOrUpdate}/>
            </div>

            <ReactModal isOpen={showModal} className="modal-content" overlayClassName="modal-overlay">
                <div className="file-warning-modal-content">
                    <p className="modal-title">File Size Warning</p>
                    <p className="file-warning-modal-text">
                        The following file is larger than 16MB and cannot be uploaded:
                    </p>
                    {file && <p className="file-warning-modal-text">{file.name}</p>}
                    <div className="modal-button-container">
                        <StandardButton text="Close" onClick={() => {
                            setShowModal(false)
                        }}/>
                    </div>
                </div>
            </ReactModal>
        </div>
    );
}
